import { BenchlingLinkService, fetchBenchlingLinkStatus } from '@/support/benchlingLink/BenchlingLink.utils';
import { _notNil } from '@/littledash';
import { useTeamEvent } from '@/support/teamEvents/useTeamEvent';
import { type FC } from 'react';

/**
 * Keeps this tab's Benchling link in step with changes made anywhere else, such as consent completed
 * in a second tab opened from a re-link prompt. The event carries no state, so the link is re-read;
 * a failed read leaves the current state rather than guessing.
 */
const BenchlingLinkChangedListener: FC = () => {
  useTeamEvent('benchling_link_changed', () => {
    fetchBenchlingLinkStatus().then((state) => {
      if (_notNil(state)) {
        BenchlingLinkService.set(state);
      }
    });
  });

  return null;
};

export default BenchlingLinkChangedListener;
